import { Callout } from 'components';
import {
    BottomBarChildren,
    StyledBottomBar,
    StyledIcon,
    StyledText,
    DisabledOverlay,
} from './PageWithBottomBar.style';
import { useBottomBar } from './useBottomBar';

export type BottomBarProps = React.PropsWithChildren &
    React.HTMLAttributes<HTMLDivElement> & {
        withPadding?: boolean;
    };

export const BottomBar: React.FC<BottomBarProps> = ({ children, withPadding, ...otherProps }) => {
    const { isDisconnected } = useBottomBar();

    return (
        <StyledBottomBar {...otherProps}>
            {isDisconnected && (
                <Callout variant="danger">
                    <StyledIcon icon="wifi-off-line" data-testid="wifi-off-line" />
                    <StyledText
                        text={'disconnected_warning'}
                        data-testid="disconnected-warning"
                        type={3}
                        weight="Bold"
                    />
                </Callout>
            )}
            <BottomBarChildren withPadding={withPadding}>
                {isDisconnected && (
                    <DisabledOverlay data-testid="disabled-overlay">{children}</DisabledOverlay>
                )}
                {!isDisconnected && children}
            </BottomBarChildren>
        </StyledBottomBar>
    );
};
